import Component from 'flarum/common/Component';
import LinkButton from 'flarum/common/components/LinkButton';
export default class MobileTabItem extends Component {
  view(vnode) {
    return m(LinkButton, {
      className: "MobileTab-item",
      href: this.attrs.href,
      icon: this.attrs.icon,
      target: this.attrs.target,
      external: this.attrs.external ?? false
    }, this.attrs.counter ? m("span", {
      className: "Bubble"
    }, this.attrs.counter) : '', vnode.children);
  }
}
flarum.reg.add('acpl-mobile-tab', 'forum/components/MobileTabItem', MobileTabItem);